var map = {
	"./alldelete.svg": 43159,
	"./allrecover.svg": 89938,
	"./arr.svg": 50706,
	"./arrow.svg": 36996,
	"./back.svg": 39344,
	"./check-active.svg": 80218,
	"./check.svg": 23075,
	"./close.svg": 55383,
	"./deletefile.svg": 6334,
	"./downloadfile.svg": 69927,
	"./file.svg": 96595,
	"./folder-menu.svg": 28407,
	"./folder.svg": 98737,
	"./grid-mode.svg": 47155,
	"./import.svg": 39202,
	"./list-mode.svg": 9095,
	"./menuarr.svg": 19993,
	"./movefile.svg": 36920,
	"./new.svg": 31893,
	"./openfile.svg": 17503,
	"./recoverfile.svg": 58617,
	"./search.svg": 24853,
	"./sort-arr.svg": 83327,
	"./storage-icon.svg": 16030,
	"./tips-vip.svg": 54637
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2935;